export function formatAmount(amount) {
  const num = Number(amount);
  if (num !== num || num === Infinity || num === -Infinity) {
    return '0.00';
  }
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}